import styled from 'styled-components';

import CapsuleIcon from 'src/app/components/Elements/CapsuleIcon';
import { Section } from 'src/app/components/Elements/Section';
import { MAX_WIDTH_CONTAINER } from 'src/consts';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

// Page Content

export const SectionWrapper = styled(Section)`
  flex: 1 1 auto;
  padding: 12rem;

  ${props => props.theme.mediaQueries.largeDown} {
    padding: ${props => props.theme.space.s9} ${props => props.theme.space.s9} 20rem;
  }

  ${props => props.theme.mediaQueries.mediumDown} {
    padding: ${props => props.theme.space.s9} ${props => props.theme.space.s7} 20rem;
  }

  ${props => props.theme.mediaQueries.smallDown} {
    padding: ${props => props.theme.space.s7} ${props => props.theme.space.s5} 16rem;
  }
`;

export const SectionContent = styled.div`
  position: relative;
  z-index: 1;
  max-width: ${MAX_WIDTH_CONTAINER};
  margin: 0 auto;
`;

export const ZipCodeDeliverableCheckWrapper = styled.div`
  max-width: 80rem;
`;

export const StyledHeartIcon = styled(props => <CapsuleIcon {...props} />)`
  position: absolute;
  path,
  circle {
    fill: ${props => props.theme.colors.capsuleRed} !important;
  }
  width: 44.6rem;
  height: 42.4rem;
  right: 5%;
  bottom: -5%;
  ${props => props.theme.mediaQueries.extraLargeDown} {
    width: auto;
    max-width: 80%;
    height: 45%;
    right: 5%;
    bottom: -5%;
  }
  ${props => props.theme.mediaQueries.largeDown} {
    height: 40%;
    right: 5%;
    bottom: -5%;
  }
  ${props => props.theme.mediaQueries.mediumDown} {
    height: 35%;
    right: 0;
    bottom: -4%;
  }
  ${props => props.theme.mediaQueries.smallDown} {
    height: 30%;
    right: 0;
    bottom: -5%;
  }
`;

export const OrderedList = styled.ol`
  counter-reset: item;
  margin-left: ${props => props.theme.space.none};
  padding-left: ${props => props.theme.space.none};
`;

export const OrderedListItem = styled.li`
  display: block;
  margin-bottom: ${props => props.theme.space.s3};
  margin-left: ${props => props.theme.space.s5};
  &:before {
    display: inline-block;
    content: counter(item) '. ';
    counter-increment: item;
    width: ${props => props.theme.space.s5};
    margin-left: -${props => props.theme.space.s5};
  }
`;
